import './AnnotationDiscardConfirmModal.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { ColumnLayout } from '../../../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { ConfirmationModal } from '../../../../../components/ConfirmationModal';

interface IToolDeleteModalProps {
  annotationsCount: number;
  showModal: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  objectsCount: number;
  questionsCount: number;
  attributesCount: number;
}

export const AnnotationDiscardConfirmModal = observer((props: IToolDeleteModalProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <ConfirmationModal
      confirmationHeader={'confirm_discard'}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      showModal={props.showModal}
      confirmationYes={'remove'}
      loaderKey='tool-delete-confirm-button'
    >
      <ColumnLayout
        size='md'
        className='annotation-discard-confirm-modal'
      >
        <div>{t('discard_annotations_confirm')}</div>
        <div>
          <Trans
            i18nKey={'discard_annotations_related_annotations'}
            count={props.annotationsCount}
            values={{ annotationsCount: props.annotationsCount }}
            components={{ b: <b /> }}
          />
        </div>
        <ul className='related-annotations'>
          <li>
            {`${t('objects')}: `} <strong>{props.objectsCount}</strong>,
          </li>
          <li>
            {`${t('question_answers')}: `}
            <strong>{props.questionsCount}</strong>,
          </li>
          <li>
            {`${t('attributes')}: `}
            <strong>{props.attributesCount}</strong>
          </li>
        </ul>
        <div>{t('discard_annotations_confirm_tip')}</div>
      </ColumnLayout>
    </ConfirmationModal>
  );
});
